import React, { useState, useEffect } from 'react';
import { Nav, NavItem, Navbar, NavLink, NavbarToggler } from 'reactstrap';
import { Menu } from 'react-feather';
import history from '../app/history';
import { NavLink as RRNavLink } from 'react-router-dom';
// import NavbarText from 'reactstrap/lib/NavbarText';
import Collapse from 'reactstrap/lib/Collapse';
import Logo from '../assets/images/hg_new.png';
import OKAPI_logo from '../assets/images/hg_logo.svg';
import { connect } from 'react-redux';
import { logoutWithJWT } from '../redux/actions/auth/loginActions';
import {
  CartApi,
  CategoryListApi,
  updateAccountApi,
} from '../redux/actions/apiActions/apiAction';
import {
  setSearchMyCatalogue,
  setCategoryMyCatalogue,
} from '../redux/actions/searchMyCatalogue/searchMyCatalogueAction';
import {
  setPromoMyCatalogue,
  setSelectedCategoryMyCatalogue,
  setCategoryName,
  setSubCategoryName,
  setCategorySEODesc,
  setCategorySEOKey,
  setSubCategorySEODesc,
  setSubCategorySEOKey,
} from '../redux/actions/searchMyCatalogue/searchMyCatalogueAction';
import { Row, Col } from 'reactstrap';

const NavbarNew = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [category, setCategory] = useState([]);
  const toggleTip = () => setTooltip(!tooltip);
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => {
    // console.log(window.innerWidth);
    if (window.innerWidth <= 991) {
      setCollapsed(!collapsed);
    }
  };

  const [search, setSearch] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(search);
    props.setSearchMyCatalogue(search);
    setSearch('');
    if (window.innerWidth <= 991) setCollapsed(!collapsed);
    history.push('my-catalogue');
  };

  const logoutFunction = async () => {
    await props.logoutWithJWT();
    toggleNavbar();
  };

  const myAccountFunction = () => {
    toggleNavbar();
    history.push('/account');
  };
  useEffect(() => {
    async function fetchData() {
      // let CartApi = props.CartApi;
      // console.log(collapsed, 'collapsed');

      await props.CartApi();
    }

    fetchData();
  }, []);

  const toggle = () => setIsOpen(!isOpen);
  // console.log('History Here', history);
  return (
    <header className={`main-header main-header-btc ${'login-header'}`}>
      <div className="top-nav">
        <div className="cust-container">
          <Navbar className="" expand="md">
            {/* <NavbarBrand onClick={() => history.push('/home')}> */}
            <Row className="nav-Image-width" onClick={() => history.push('/')}>
              <Col sm={12} className="d-flex">
                <img src={Logo} alt="Logo" className="brand-img" />
                <img src={OKAPI_logo} alt="Logo" className="brand-img1" />
              </Col>
            </Row>
            {/* </NavbarBrand> */}

            <div className="right-box-navbar">
              <div className="cart-icon-login-navbar">
                <a
                  className="add-cart"
                  tag={RRNavLink}
                  onClick={() => history.push('/cart')}
                >
                  <i className="icon-cart"></i>
                  <span className="count">{props.cartProductCount}</span>
                </a>
              </div>
            </div>

            <Collapse
              isOpen={!collapsed}
              navbar
              className="app-links-nav navbar-btc"
              id="appLinksNav1"
            >
              <a className="menu-close-button" onClick={toggleNavbar}>
                <i className="icon-close"></i>
              </a>

              <nav className="cust-container nav-container navv">
                <Nav className="nav-links">
                  <div className="sticky-header">
                    <NavItem className="sticky-header"></NavItem>
                  </div>
                  <NavItem>
                    <NavLink
                      to="/"
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                      onClick={toggleNavbar}
                    >
                      Home
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to="/my-catalogue/all"
                      onClick={() => {
                        if (history.location.pathname === '/my-catalogue/all') {
                          window.location.reload(false);
                        }
                        props.setCategoryName('');
                        props.setSubCategoryName('');
                        props.setCategorySEODesc('');
                        props.setSubCategorySEODesc('');
                        props.setCategorySEOKey('');
                        props.setSubCategorySEOKey('');
                        props.setCategoryMyCatalogue([]);
                        props.setSearchMyCatalogue('');
                        props.setSelectedCategoryMyCatalogue([]);
                        toggleNavbar();
                      }}
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                    >
                      Products
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                        <NavLink to="" activeClassName="active" tag={RRNavLink} className="text-nav">
                          Promotion
                        </NavLink>
                      </NavItem> */}
                  <NavItem>
                    <NavLink
                      to="/about"
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                      onClick={toggleNavbar}
                    >
                      About
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to="/news"
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                      onClick={toggleNavbar}
                    >
                      News
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to="/contactus"
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                      onClick={toggleNavbar}
                    >
                      Contact
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                        <NavLink
                          to=""
                          activeClassName="active"
                          tag={RRNavLink}
                          className="text-nav"
                          // onClick={toggleNavbar}
                        >
                          REGISTER
                        </NavLink>
                      </NavItem> */}
                  <NavItem>
                    <NavLink
                      to=""
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                      onClick={() =>
                        window.open(
                          // "http://localhost:3000/admin/",
                          'https://handygarments.co.za/admin/',
                          '_blank'
                        )
                      }
                    >
                      Login
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to=""
                      activeClassName="active"
                      tag={RRNavLink}
                      className="text-nav"
                      onClick={() =>
                        window.open(
                          'https://handygarments.co.za/admin/customer-account-registration',
                          '_blank'
                        )
                      }
                    >
                      Register
                    </NavLink>
                  </NavItem>
                </Nav>
              </nav>
            </Collapse>

            <div className="right-box">
              <div className="cart-icon-login">
                <a
                  className="add-cart"
                  tag={RRNavLink}
                  onClick={() => history.push('/cart')}
                >
                  <i className="icon-cart"></i>
                  <span className="count">{props.cartProductCount}</span>
                </a>
              </div>
              <NavbarToggler
                onClick={toggleNavbar}
                // className='menu-toggle btn-toggle collapsed navbar-toggler'
                className=" menu-toggle btn-toggle navbar-toggler mr-3"
                // onClick={toggle}
                // data-toggle="collapse"
                // data-target="#collapsibleNavbar"
              >
                <Menu />
              </NavbarToggler>
            </div>
          </Navbar>
        </div>
      </div>

      {/* <Collapse
        isOpen={isOpen}
        navbar
        className='app-links-nav'
        isOpen={isOpen}
        id='appLinksNav1'
      > */}

      {/* {props.values.loginFlag === false && (
        <div className="navv">
          <nav className="cust-container">
            <Nav className="nav-links">
              <NavItem className="login-logo">
              </NavItem>
            </Nav>
          </nav>
        </div>
      )} */}
    </header>
  );
};

const mapStateToProps = (state) => {
  // console.log('state', state);
  return {
    cartProductCount: state.searchMyCatalogue.cartCount,
    categoryList: state.searchMyCatalogue.categoryList,
  };
};

export default connect(mapStateToProps, {
  logoutWithJWT,
  CartApi,
  setSearchMyCatalogue,
  setCategoryMyCatalogue,
  CategoryListApi,
  updateAccountApi,
  setPromoMyCatalogue,
  setSelectedCategoryMyCatalogue,
  setCategoryName,
  setSubCategoryName,
  setSubCategorySEODesc,
  setSubCategorySEOKey,
  setCategorySEODesc,
  setCategorySEOKey,
})(NavbarNew);
